import React from 'react';

// Minimal shim for @dnd-kit/sortable to satisfy bundler when package resolution fails
// This provides basic no-op implementations used at build-time. For full behavior,
// the real @dnd-kit/sortable package should be installed.

export function arrayMove(array: any[], from: number, to: number) {
  const copy = array.slice();
  const val = copy.splice(from, 1)[0];
  copy.splice(to, 0, val);
  return copy;
}

export const SortableContext: React.FC<{ items?: any[]; strategy?: any; children?: React.ReactNode }> = ({ children }) => {
  return React.createElement(React.Fragment, null, children);
};

export function sortableKeyboardCoordinates() {
  return () => ({ x: 0, y: 0 });
}

export function useSortable(_opts: any) {
  // Return minimal structure expected by consuming code
  return {
    attributes: {},
    listeners: {},
    setNodeRef: () => {},
    transform: null,
    transition: undefined,
    isDragging: false,
  };
}

export const verticalListSortingStrategy = () => {};